module.exports = __webpack_public_path__ + "static/img/net.f225640.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/net.png
// module id = OzPX
// module chunks = 0